var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mb-3"},[_c('v-col',[_c('h1',[_vm._v(_vm._s(_vm.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }